import { useMemo, useState } from 'react'

import EmojiSelect from '@space-lib/components/emojiSelect'
import useTranslation from '@space-lib/hooks/useTranslation'
import CustomInput from '@space-shell/common/components/customInput'
import CustomSelect from '@space-shell/common/components/customSelect'
import CustomTextArea from '@space-shell/common/components/customTextarea'
import { useForm } from '@space-shell/common/hooks/useForm'

import { formFields, getFieldsConfig } from './constants'

import type { FormFields, SelectOption } from './types'

import { useGetGroups } from '../hooks'

const FormModal = () => {
  const { t } = useTranslation()
  const { data: formData, setFormData } = useForm<FormFields>()
  const [fieldsSize, setFieldsSize] = useState(getFieldsConfig(formData))
  const { groupCommunitiesList } = useGetGroups()

  const groupOptions = useMemo(() => {
    return (
      groupCommunitiesList?.reduce((result: SelectOption[], item) => {
        result.push({ label: item.name, value: item.id })

        return result
      }, []) ?? []
    )
  }, [groupCommunitiesList])
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target

    setFieldsSize((current) => {
      const newState = { ...current }
      newState[name].currentSize = value.length

      return newState
    })
    setFormData(name as keyof FormFields, value)
  }

  const handleSelect = (event: Event) => {
    const groupId =
      (event as CustomEvent).detail?.value !== undefined
        ? Number((event as CustomEvent).detail?.value)
        : undefined
    setFormData(formFields.idGroup.name as keyof FormFields, groupId)
  }

  const handleEmojiSelect = (payload: string) => {
    setFormData(formFields.icon.name as keyof FormFields, payload)
  }

  return (
    <>
      <div className='_d-flex _align-items-start'>
        <EmojiSelect
          name={formFields.icon.name}
          value={formData.icon.value}
          onChange={handleEmojiSelect}
          label={t('modal.create_community.label_icon')}
          labelClassName='_text-gray-900'
        />

        <CustomInput
          value={formData.name.value}
          onChange={handleChange}
          label={t('modal.create_community.label_name')}
          name={formFields.name.name}
          className='_w-full _mb-0 _text-gray-900'
          placeholder={t('modal.create_community.placeholder_name')}
          maxSize={fieldsSize.name.maxSize}
          currentSize={fieldsSize.name.currentSize}
        />
      </div>
      <CustomTextArea
        label={t('modal.create_community.label_description')}
        name={formFields.description.name}
        value={formData.description.value}
        onChange={handleChange}
        placeholder={t('modal.create_community.placeholder_description')}
        maxSize={fieldsSize.description.maxSize}
        currentSize={fieldsSize.description.currentSize}
        className='_mt-5 _mb-0 _text-gray-900'
      />
      <CustomSelect
        name={formFields.idGroup.name}
        onChange={handleSelect}
        label={t('modal.create_community.label_communities_group')}
        placeholder={t('modal.create_community.placeholder_select_group')}
        items={groupOptions}
        selected={formData.idGroup.value}
        className='_mt-5 _mb-0 _text-gray-900'
      />
    </>
  )
}

export default FormModal
